import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { MODAL_GIFT_GAB_PRO, POPOVER_PROFILE_OPTIONS } from '../../constants'
import { openPopover } from '../../actions/popover'
import BackButton from '../back_button'
import Button from '../button'
import Heading from '../heading'
import { openModal } from '../../actions/modal'

const giftIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" className={_s.inheritFill}>
    <path d="M19.5 7.75H18.1C18.5 7.27 18.75 6.67 18.75 6C18.75 4.48 17.52 3.25 16 3.25C14.32 3.25 12.84 4.14 12 5.46C11.16 4.14 9.68 3.25 8 3.25C6.48 3.25 5.25 4.48 5.25 6C5.25 6.67 5.5 7.27 5.9 7.75H4.5C3.81 7.75 3.25 8.31 3.25 9V11.5C3.25 12.1 3.68 12.58 4.25 12.7V19.5C4.25 20.19 4.81 20.75 5.5 20.75H18.5C19.19 20.75 19.75 20.19 19.75 19.5V12.7C20.32 12.58 20.75 12.1 20.75 11.5V9C20.75 8.31 20.19 7.75 19.5 7.75ZM19.25 11.25H12.75V9.25H19.25V11.25ZM16 4.75C16.69 4.75 17.25 5.31 17.25 6C17.25 6.69 16.69 7.25 16 7.25H12.84C13.18 5.82 14.47 4.75 16 4.75ZM8 4.75C9.53 4.75 10.82 5.82 11.16 7.25H8C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM4.75 9.25H11.25V11.25H4.75V9.25ZM5.75 12.75H11.25V19.25H5.75V12.75ZM18.25 19.25H12.75V12.75H18.25V19.25Z" className={[_s.inheritFill].join(' ')} />
  </svg>
)

class ProfileNavigationBar extends React.PureComponent {

  handleOpenMore = () => {
    this.props.openProfileOptionsPopover({
      account: this.props.account,
      targetRef: this.openMoreNode,
      position: 'bottom',
    })
  }

  setOpenMoreNodeRef = (n) => {
    this.openMoreNode = n
  }

  handleOpenGift = () => {
    const { account } = this.props
    const username = !!account ? account.get('acct') : ''

    this.props.onOpenGiftGabPROModal(username)
  }

  render() {
    const { headerSrc, opacity, titleHTML, navTitleTop, theme, isSolid } = this.props

    let color, bgColor, colorClass, bgColorClass, brightness, textColorClass, mainBg, mainStyles, innerStyles
    const isDark = ['black', 'night', 'muted'].indexOf(theme) > -1
    if (isDark) {
      color = 'black'
      bgColor = 'white'
      colorClass = [_s.fillBlack, _s.cBlack].join(' ')
      textColorClass = _s.cWhite
      bgColorClass = _s.bgWhite
      brightness = 'brightness(0.35)'
    } else {
      color = 'white'
      bgColor = 'black'
      colorClass = [_s.fillWhite, _s.cWhite].join(' ')
      textColorClass = _s.cBlack
      bgColorClass = _s.bgBlack
      brightness = 'brightness(5)'
    }

    if (opacity > 0.9) {
      bgColor = 'none'
      bgColorClass = _s.bgTransparent
      if (isDark) {
        color = 'white'
        colorClass = [_s.fillWhite, _s.cWhite].join(' ')
        textColorClass = _s.cWhite
      } else {
        color = 'black'
        colorClass = [_s.fillBlack, _s.cBlack].join(' ')
        textColorClass = _s.cBlack
      }
    }

    if (isSolid) {
      mainBg = _s.bgNavigation
      mainStyles = {}
      innerStyles = {}
    } else {
      mainBg = _s.bgTransparent
      mainStyles = {
        backgroundColor: opacity > 0.9 ? color : 'transparent',
      }
      innerStyles = {
        top: '-5px',
        right: '-5px',
        bottom: '-5px',
        left: '-5px',
        backgroundImage: `url('${headerSrc}')`,
        backgroundPosition: 'center bottom',
        filter: `blur(8px) ${brightness}`,
        transform: 'scale(1.25)',
        opacity,
      }
    }

    return (
      <div
        className={[_s.d, _s.minH53PX, mainBg, _s.aiCenter, _s.overflowHidden, _s.z4, _s.top0, _s.right0, _s.left0, _s.posFixed].join(' ')}
        style={mainStyles}
      >
        <div
          className={[_s.d, _s.posAbs, _s.z2, _s.overflowHidden].join(' ')}
          style={innerStyles}
        />
        <div className={[_s.d, _s.z4, _s.flexRow, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR, _s.w100PC].join(' ')}>
          
          <div className={[_s.d, _s.flexRow, _s.minH53PX, _s.aiCenter, _s.ml15, _s.maxW100PC86PX, _s.overflowHidden].join(' ')}>
            <BackButton
              className={[_s.h40PX, _s.w40PX, bgColorClass, _s.pl10, _s.pr10, _s.circle].join(' ')}
              iconSize='18px'
              iconClassName={[_s.mr2, colorClass].join(' ')}
            />

            <div
              className={[_s.d].join(' ')} 
              style={{
                transform: `translateY(${navTitleTop}px)`,
              }}
            >
              <Heading size='h1'>
                <span
                  className={[_s.w100PC, _s.textOverflowEllipsis, textColorClass].join(' ')}
                  dangerouslySetInnerHTML={{ __html: titleHTML }}
                />
              </Heading>
            </div>
          </div>

          <div className={[_s.d, _s.minH53PX,_s.flexRow,  _s.jcCenter, _s.aiCenter, _s.mlAuto, _s.mr15].join(' ')}>
            <Button
              isOutline
              title='Gift GabPRO'
              color={color}
              iconClassName={colorClass}
              backgroundColor={bgColor}
              className={[_s.jcCenter, _s.aiCenter, _s.fillWhite_onHover, _s.fillBrand, _s.ml10, _s.h40PX, _s.w40PX, _s.px2, _s.py2].join(' ')}
              onClick={this.handleOpenGift}
            >
              {giftIcon}
            </Button>
            <Button
              icon='ellipsis'
              iconSize='26px'
              title='More options'
              iconClassName={colorClass}
              color={color}
              backgroundColor={bgColor}
              className={[_s.jcCenter, _s.aiCenter, _s.ml5, _s.px10, _s.h40PX, _s.w40PX].join(' ')}
              onClick={this.handleOpenMore}
              buttonRef={this.setOpenMoreNodeRef}
            />
          </div>

        </div>

      </div>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  openProfileOptionsPopover(props) {
    dispatch(openPopover(POPOVER_PROFILE_OPTIONS, props))
  },
  onOpenGiftGabPROModal(username) {
    dispatch(openModal(MODAL_GIFT_GAB_PRO, { username }))
  },
})

ProfileNavigationBar.propTypes = {
  headerSrc: PropTypes.string,
  titleHTML: PropTypes.string,
  showBackBtn: PropTypes.bool,
}

export default connect(null, mapDispatchToProps)(ProfileNavigationBar)